"use strict";
import $ from "jquery";
import _ from "underscore";
import DataStoreService from "../accounts_payable/data_store_service";
import ApiService from "../services/api_service";
export default {
  index: function(searchParams) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.get("/api/email_messages", searchParams).then(DataStoreService.responseHandler, _.identity).then((data) => data)
    );
  },
  merge: function(ids) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/email_messages/merge",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({ ids })
      }).then(DataStoreService.responseHandler, _.identity)
    );
  },
  send: function(email) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/email_messages",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify(email)
      }).then(DataStoreService.responseHandler, _.identity)
    );
  },
  sendRejectionNote: function(email) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/email_messages/" + email.id + "/send_rejection_note",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify(email)
      }).then(DataStoreService.responseHandler, _.identity)
    );
  },
  forward: function(params) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/email_messages/forward",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify(params)
      }).then(DataStoreService.responseHandler, _.identity)
    );
  }
};
